import './../../style/dragnorder.css';
import {randomShuffle, insertElement, arrayEquals } from "./util"
import DragElement from "./DragElement"
import DropElement from "./DropElement"
import { useContext, useEffect, useState } from 'react';
import { isNeitherNullNorUndefined } from '../../utils/functions';
import OrderDropElementSmall from "./OrderDropSmall"
import OrderDragElementSmall from './OrderDragSmall';
import OrderDropElement from "./OrderDropElement"
import OrderDragElement from './OrderDragElement';


export default function DragAndOrderSmall({title, originalDrags, correctAnswer, wrongAnswer}){
    const [shuffledDragElements, setShuffledDragElements] = useState()
    const [currentDragPosition, setCurrentDrag] = useState(null)
    const [finished, setFinished] = useState(false)
    const [success, setSuccess] = useState(false)



    useEffect(() => {
        const randomShuffled = randomShuffle(originalDrags)
        setShuffledDragElements(randomShuffled)
    }, [])

    useEffect(() => {
        
    }, [currentDragPosition])




    function informAboutDrop(dropItemPosition){
        const updatedDragElements = insertElement([...shuffledDragElements], currentDragPosition, dropItemPosition)
        setShuffledDragElements(updatedDragElements)
        setCurrentDrag(null)
    }

    function informAboutDragClick(dragItemPosition){
        console.log("----------------------------")
        console.log("currentDragPosition: " + currentDragPosition)
        console.log("dragItemPosition: " + dragItemPosition)
        
        setCurrentDrag(dragItemPosition)

    }

    function resetDnO(){
        setFinished(false)
        setSuccess(false)
        const randomShuffled = randomShuffle(originalDrags)
        setShuffledDragElements(randomShuffled)

    }

    function checkResult(){
        setFinished(true)
        
        console.log("originalDrags")
        console.log(originalDrags)
        console.log("shuffledDragElements")
        console.log(shuffledDragElements)
        console.log("-----------------------")

        if(arrayEquals(originalDrags, shuffledDragElements)){
            setSuccess(true)
            console.log("correct!!!!!!!!!!!!!!!!!")
        } else {
            console.log("false!!!!!!!!!!!!!!!!!")

        }
    }


    



    return(
        <div className='text-center'>
            <div className="mb-3">{title}</div>
            <div className={"dragnorder " + (finished && success ? "dndSuccess " : finished && !success && "dndFail")}>
                <div className='dnoContainer '>
               {  !finished &&   <OrderDropElementSmall belongsTo={99} 
                        informAboutDrop={informAboutDrop}
                        readyToReceive={currentDragPosition}
                    />}

        {
                    isNeitherNullNorUndefined(shuffledDragElements) && shuffledDragElements.map((dragItem, index) => {
                        if(finished){
                            return <div className='dnoItemDragTarget mt-3' key={index} >
                                    <OrderDragElementSmall informAboutDragClick={informAboutDragClick}
                                                    content={dragItem}
                                                    dragItemPosition={index}
                                                    finished={finished}
                                                    clicked={currentDragPosition === index}
                                    />

                                </div>
                        } else {
                            return <div className='dnoItemDragTarget' key={index} >
                                    <OrderDragElementSmall informAboutDragClick={informAboutDragClick}
                                                    content={dragItem}
                                                    dragItemPosition={index}
                                                    finished={finished}
                                                    clicked={currentDragPosition === index}
                                    />

                                    <OrderDropElementSmall belongsTo={index} 
                                                    informAboutDrop={informAboutDrop}
                                                    readyToReceive={currentDragPosition}    // != null
                                                    /> 
                                </div>
                        }  
                    })
                }
                {finished && <div className='mt-3'>
                    {success 
                    ? 
                    <div className="droppedElement dndCorrectMsg"
                        dangerouslySetInnerHTML={{__html: correctAnswer}}
                    />  
                    :
                    <div className="droppedElement dndWrongMsg"
                        dangerouslySetInnerHTML={{__html: wrongAnswer}}
                    />  
                    }
                    
                </div>}

                <div className="flex justify-center mt-3" >
                {
                    finished 
                    ?
                    <button className="btn resetButton " onClick={resetDnO}>
                        <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 1v5h-5M2 19v-5h5m10-4a8 8 0 0 1-14.947 3.97M1 10a8 8 0 0 1 14.947-3.97"/>
                        </svg>
                        <div className='ml-1'>Reset</div>
                    </button>
                    :
                    <button className="btn resetButton " onClick={checkResult}>
                        <div className='ml-1'>Überprüfen</div>
                    </button>


                }
                    
                </div>
                </div>
            </div> 
        </div>
        
    )
}